export const DEFAULT_GROUP_COVER_URL = 'assets/images/group-cover-default.svg';
export const EDIT_LIST_PREVIEW_COUNT = 3;
